import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../../../../constants/urls";
import {
  Container,
  MainContainer,
  InnerTopContainer,
  Heading,
  Description,
  BottomContainer,
  ProjectsContainer,
  ImgContainer,
  CardInnerContainer,
  Title,
  Amount,
  Card,
  Button,
} from "./styled.components";
const OurProjects = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${BACKEND_URL}/projects`).then((res) => {
      console.log(res);
      setProjects(res.data.projects);
    });
  }, []);

const firstSixProjects = (projects || []).slice(0, 6);

  return (
    <Container>
      <MainContainer>
        <InnerTopContainer>
          <Heading>Our Projects</Heading>
          <Description>
            HHH and Sons Presents a Proud Past And Will Keep The Promise For
            Days To Come
          </Description>
        </InnerTopContainer>
        <BottomContainer>
          <ProjectsContainer>
            {firstSixProjects.map((_proj) => {
              console.log(_proj);
              return (
                <Card>
                  <ImgContainer src={_proj.images[0]}></ImgContainer>
                  <CardInnerContainer>
                    <Title>{_proj.title}</Title>
                    {/* <Amount>{`PKR ${_proj.amount} /-`}</Amount> */}
                  </CardInnerContainer>
                </Card>
              );
            })}
          </ProjectsContainer>
        </BottomContainer>
        <Button onClick={() => navigate("/projects")}>
          See More <span>&#8594;</span>
        </Button>
      </MainContainer>
    </Container>
  );
};

export default OurProjects;
